import React from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import adminRoutes from 'apps/admin/adminRoutes';
import managerRoutes from 'apps/manager/managerRoutes';
import userRoutes from 'apps/user/userRoutes';
import systemRoutes from 'apps/system/systemRoutes';
import authRoutes from 'auth/authRoutes';
import viewsRoutes from 'views/routes';
import { getRole } from 'auth/Login/AuthService';

const Routes = (): JSX.Element => {
  const userRole = getRole();

  return (
    <ReactRoutes>
      {authRoutes.map((item, i) => (
        <Route key={i} path={item.path} element={item.renderer()} />
      ))}
      {viewsRoutes.map((item, i) => (
        <Route key={i} path={item.path} element={item.renderer()} />
      ))}
      {adminRoutes.map((item, i) => {
        const key = `admin-route-${i}`;

        if (userRole === 'ADMIN') {
          return <Route key={key} path={item.path} element={item.renderer()} />;
        } else {
          // Redirect to login using Navigate within element prop
          return (
            <Route
              key={key}
              path={item.path}
              element={<Navigate to="/login" replace />}
            />
          );
        }
      })}
      {managerRoutes.map((item, i) => {
        const key = `manager-route-${i}`;

        if (userRole === 'MANAGER') {
          return <Route key={key} path={item.path} element={item.renderer()} />;
        } else {
          // Redirect to login using Navigate within element prop
          return (
            <Route
              key={key}
              path={item.path}
              element={<Navigate to="/login" replace />}
            />
          );
        }
      })}
      {userRoutes.map((item, i) => {
        const key = `user-route-${i}`;

        if (userRole === 'USER') {
          return <Route key={key} path={item.path} element={item.renderer()} />;
        } else {
          // Redirect to login using Navigate within element prop
          return (
            <Route
              key={key}
              path={item.path}
              element={<Navigate to="/login" replace />}
            />
          );
        }
      })}
      {systemRoutes.map((item, i) => {
        const key = `system-route-${i}`;

        if (userRole === 'SYSTEM') {
          return <Route key={key} path={item.path} element={item.renderer()} />;
        } else {
          // Redirect to login using Navigate within element prop
          return (
            <Route
              key={key}
              path={item.path}
              element={<Navigate to="/login" replace />}
            />
          );
        }
      })}
      {/* Fallback route */}
      <Route path="*" element={<Navigate replace to="/not-found-cover" />} />
    </ReactRoutes>
  );
};

export default Routes;
